import { render, staticRenderFns } from "./ExamManage.vue?vue&type=template&id=40e3cb16"
import script from "./ExamManage.vue?vue&type=script&lang=ts"
export * from "./ExamManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports